var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class MediaMixer {
    /**
     * @deprecated - 使用 delay0
     */
    get delay() {
        return this.delay0;
    }
    /**
     * 延迟 media0
     *
     * @deprecated
     * @param delay - 正数:延迟 负数:提前  单位:ms
     */
    set delay(delay) {
        this.delay0 = delay;
    }
    get delay0() {
        return this._delay0;
    }
    set delay0(delay) {
        this._delay0 = delay;
        if (this.isFistPlay) {
            return;
        }
        this.startDelay(this._delay0, this._delay1);
    }
    get delay1() {
        return this._delay1;
    }
    set delay1(delay) {
        this._delay1 = delay;
        if (this.isFistPlay) {
            return;
        }
        this.startDelay(this._delay0, this._delay1);
    }
    startDelay(delay0, delay1, startAt) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.audioBuffer0 && this.audioBuffer1 && this.audioCtx) {
            const newAudioBuffer0 = this.delayAudioBuffer(delay0, this.audioBuffer0);
            const newAudioBuffer1 = this.delayAudioBuffer(delay1, this.audioBuffer1);
            // this.delaySourceNode0.stop()
            (_a = this.delaySourceNode0) === null || _a === void 0 ? void 0 : _a.disconnect();
            // this.delaySourceNode1.stop()
            (_b = this.delaySourceNode1) === null || _b === void 0 ? void 0 : _b.disconnect();
            this.delaySourceNode0 = (_c = this.audioCtx) === null || _c === void 0 ? void 0 : _c.createBufferSource();
            this.delaySourceNode0 && (this.delaySourceNode0.buffer = newAudioBuffer0);
            this.gainNode0 && ((_d = this.delaySourceNode0) === null || _d === void 0 ? void 0 : _d.connect(this.gainNode0));
            this.delaySourceNode1 = (_e = this.audioCtx) === null || _e === void 0 ? void 0 : _e.createBufferSource();
            this.delaySourceNode1 && (this.delaySourceNode1.buffer = newAudioBuffer1);
            this.gainNode1 && ((_f = this.delaySourceNode1) === null || _f === void 0 ? void 0 : _f.connect(this.gainNode1));
            const offset = startAt ? startAt : this.audioCtx.currentTime - this._diff;
            (_g = this.delaySourceNode0) === null || _g === void 0 ? void 0 : _g.start(0, offset);
            (_h = this.delaySourceNode1) === null || _h === void 0 ? void 0 : _h.start(0, offset);
            this.video && (this.video.currentTime = offset - delay0 / 1000);
            this._delay0 = delay0;
            this._delay1 = delay1;
        }
    }
    /**
     * 延迟或提前audioBuffer
     * @param delay
     * @param audioBuffer
     * @private
     */
    delayAudioBuffer(delay, audioBuffer) {
        let newAudioBuffer = audioBuffer;
        if (this.audioCtx && audioBuffer) {
            if (delay > 0) {
                // delay
                const buffer = new Float32Array(audioBuffer.length + delay * audioBuffer.sampleRate / 1000);
                audioBuffer.copyFromChannel(buffer, 0, 0);
                newAudioBuffer = this.audioCtx.createBuffer(1, audioBuffer.length + delay * audioBuffer.sampleRate / 1000, audioBuffer.sampleRate);
                // to offset 指复制到channel上的偏移，buffer从0开始
                newAudioBuffer === null || newAudioBuffer === void 0 ? void 0 : newAudioBuffer.copyToChannel(buffer, 0, delay * audioBuffer.sampleRate / 1000);
            }
            else if (delay < 0) {
                // advance
                const buffer = new Float32Array(audioBuffer.length + delay * audioBuffer.sampleRate / 1000);
                // from offset 指channel上的偏移
                audioBuffer.copyFromChannel(buffer, 0, -delay * audioBuffer.sampleRate / 1000);
                newAudioBuffer = this.audioCtx.createBuffer(1, audioBuffer.length + delay * audioBuffer.sampleRate / 1000, audioBuffer.sampleRate);
                newAudioBuffer === null || newAudioBuffer === void 0 ? void 0 : newAudioBuffer.copyToChannel(buffer, 0, 0);
            }
        }
        return newAudioBuffer;
    }
    get gain0() {
        return this._gain0;
    }
    /**
     * 设置增益0
     * @param gain
     */
    set gain0(gain) {
        this.gainNode0 && MediaMixer.soundGain(this.gainNode0, gain);
        this._gain0 = gain;
    }
    get gain1() {
        return this._gain1;
    }
    /**
     * 设置增益1
     * @param gain
     */
    set gain1(gain) {
        this.gainNode1 && MediaMixer.soundGain(this.gainNode1, gain);
        this._gain1 = gain;
    }
    static soundGain(gainNode, gain) {
        if (gain < 0 || gain > 4) {
            throw new Error('parameters must in [0, 4]');
        }
        gainNode.gain.value = gain;
    }
    /**
     * 如果两个参数有一个是视频，media0是视频
     * @param media0
     * @param media1
     * @param video
     */
    constructor(media0, media1, video) {
        this.isFistPlay = true;
        this._delay0 = 0;
        this._delay1 = 0;
        this._diff = 0;
        this._gain0 = 1;
        this._gain1 = 1;
        this.onended = () => { return; };
        this.media0 = media0;
        this.media1 = media1;
        if (video) {
            this.video = video;
            this.video.muted = true;
            this.video.src = URL.createObjectURL(media0);
        }
    }
    /**
     * 播放前需要调用初始化
     */
    init() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.audioCtx) {
                // AudioContext first
                this.audioCtx = new AudioContext();
                // safari might block
                // await this.audioCtx.suspend()
                // ios
                // await this.audioCtx.resume()
                this.gainNode0 = this.audioCtx.createGain();
                this.gainNode1 = this.audioCtx.createGain();
                //
                const compressorNode = this.audioCtx.createDynamicsCompressor();
                this.gainNode0.connect(compressorNode);
                this.gainNode1.connect(compressorNode);
                compressorNode.connect(this.audioCtx.destination);
                this.audioBuffer0 = yield this.audioCtx.decodeAudioData(yield this.readAsArrayBuffer(this.media0));
                this.audioBuffer1 = yield this.audioCtx.decodeAudioData(yield this.readAsArrayBuffer(this.media1));
                this.delaySourceNode0 = (_a = this.audioCtx) === null || _a === void 0 ? void 0 : _a.createBufferSource();
                this.delaySourceNode1 = (_b = this.audioCtx) === null || _b === void 0 ? void 0 : _b.createBufferSource();
                this.delaySourceNode0.buffer = this.audioBuffer0;
                this.delaySourceNode1.buffer = this.audioBuffer1;
            }
        });
    }
    readAsArrayBuffer(blob) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(blob);
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = (e) => {
                    reject(e);
                };
            });
        });
    }
    play() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isFistPlay) {
                this.isFistPlay = false;
                this.currentTime = 0;
                const timer = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                    var _c, _d;
                    if (this.duration && this.currentTime >= this.duration) {
                        clearInterval(timer);
                        yield this.pause();
                        this.currentTime = 0;
                        (_c = this.delaySourceNode0) === null || _c === void 0 ? void 0 : _c.stop();
                        (_d = this.delaySourceNode1) === null || _d === void 0 ? void 0 : _d.stop();
                        this.onended();
                        this.isFistPlay = true;
                    }
                }), 100);
            }
            yield ((_a = this.video) === null || _a === void 0 ? void 0 : _a.play());
            yield ((_b = this.audioCtx) === null || _b === void 0 ? void 0 : _b.resume());
        });
    }
    pause() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = this.audioCtx) === null || _a === void 0 ? void 0 : _a.suspend());
            (_b = this.video) === null || _b === void 0 ? void 0 : _b.pause();
        });
    }
    /**
     * 获取当前时间
     * @return - 单位:s
     */
    get currentTime() {
        return this.audioCtx ? this.audioCtx.currentTime - this._diff : 0;
    }
    /**
     * 设置当前时间
     * @param startAt - 单位:s
     */
    set currentTime(startAt) {
        if (this.isFistPlay) {
            return;
        }
        if (this.audioCtx) {
            this._diff = this.audioCtx.currentTime - startAt;
            this.startDelay(this._delay0, this._delay1, startAt);
        }
    }
    get duration() {
        var _a, _b;
        if (((_a = this.delaySourceNode0) === null || _a === void 0 ? void 0 : _a.buffer) && ((_b = this.delaySourceNode1) === null || _b === void 0 ? void 0 : _b.buffer)) {
            return Math.min(this.delaySourceNode0.buffer.duration, this.delaySourceNode1.buffer.duration);
        }
        else {
            return undefined;
        }
    }
    /**
     * 获取 MediaGenerator MergeSoundOptions 中的 delay0 和 delay1
     */
    getMediaGeneratorMergeSoundOptions() {
        return {
            volume0: this._gain0,
            volume1: this._gain1,
            delay0: this._delay0,
            delay1: this._delay1,
        };
    }
    /**
     * 关闭MediaMixer，释放资源
     */
    close() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.audioCtx && this.audioCtx.close && this.audioCtx.state !== 'closed') {
                yield this.audioCtx.close();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.audioCtx = undefined;
            }
            if ((_a = this.video) === null || _a === void 0 ? void 0 : _a.src) {
                URL.revokeObjectURL(this.video.src);
            }
        });
    }
}
